import React, { forwardRef } from 'react';
import { DatePicker, DatePickerProps } from '@heroui/react';
import cn from 'classnames';
import styles from './CustomDatepicker.module.scss';

interface CustomDatepickerProps extends Omit<DatePickerProps, 'classNames'> {
  errorMessage?: string;
  showError?: boolean;
}

export const CustomDatepicker = forwardRef<HTMLDivElement, CustomDatepickerProps>(
  (props, ref) => {
    const { errorMessage, showError = false, label = 'Date', value, ...datePickerProps } = props;

    const isInvalid = !!errorMessage;
    const classnamesDatepicker = {
      base: styles.datepickerBase,
      label: cn(styles.datepickerInputLabel, isInvalid ? styles.error : ''),
      inputWrapper: cn(styles.datepickerInputWrapper, isInvalid ? styles.error : ''),
      innerWrapper: styles.innerWrapper,
      input: cn(styles.datepickerText, styles.valueText),
      segment: styles.segment,
      separator: styles.separator,
      calendar: styles.datepickerCalendar,
      calendarContent: styles.datepickerCalendarContent,
      helperWrapper: styles.errorMessage,
    };

    const dateValue = value === undefined || value === null ? null : value;

    return (
      <DatePicker
        {...datePickerProps}
        ref={ref}
        value={dateValue}
        label={label}
        labelPlacement="outside"
        popoverProps={{ shouldBlockScroll: false }}
        isInvalid={isInvalid}
        errorMessage={showError ? errorMessage : undefined}
        classNames={classnamesDatepicker}
      />
    );
  },
);

CustomDatepicker.displayName = 'CustomDatepicker';
